import { select, Selection } from 'd3'
import { Input } from './Input';
import { GhostFollowerElement } from '../utils/GhostFollowerElement';
import "/styles/components/InputTooltipWrapperValidator.scss";

interface InputTooltipWrapperValidatorExtras {
    tooltipParent?: Selection<any, any, any, any> | HTMLElement
    onValide?: (valid: boolean) => void
}

export class InputTooltipWrapperValidator {
    private extras: InputTooltipWrapperValidatorExtras
    private isInputValid: boolean
    private input: HTMLInputElement
    private tooltipMsg: TSelection<"div">
    private tooltipMsgGhostManager: GhostFollowerElement

    constructor(input: HTMLInputElement, extras?: InputTooltipWrapperValidatorExtras) {
        this.extras = extras || {};
        this.input = input

        input.addEventListener("input", () => this.Valide())
        input.addEventListener("change", () => this.Valide())

        const tooltipContainer: TSelection = !this.extras.tooltipParent
            ? select(document.body)
            : (this.extras.tooltipParent instanceof HTMLElement
                ? select(this.extras.tooltipParent)
                : this.extras.tooltipParent)

        this.tooltipMsg = tooltipContainer.append<HTMLDivElement>("div")
            .attr("class", "input-tooltip-validator")
            .classed("hide", true)
            .text("error")

        this.tooltipMsgGhostManager = new GhostFollowerElement(
            // tooltip (ghost)
            this.tooltipMsg.node(),
            // ghost reference
            input,
            // extras
            {
                onCalcRelocateGhost: ({ top, left }, ghost) => ({
                    top: top - ghost.clientHeight - 10,
                    left: left
                })
            }
        )
    }

    private Valide(): boolean {
        const { valid, message } = Input._GenericValitador(this.input);
        this.isInputValid = valid;
        this.tooltipMsg.classed("hide", valid);
        this.extras.onValide?.(valid);
        if (!valid) {
            const p = this.tooltipMsg.node().parentElement
            this.tooltipMsg.remove();
            p.append(this.tooltipMsg.node())

            this.tooltipMsg.html(message);
            this.tooltipMsgGhostManager._Refresh();
        }
        return valid;
    }

    public _IsValid(): boolean {
        if (this.isInputValid !== undefined) {
            return this.isInputValid;
        }
        return this.Valide();
    }
}